import React from 'react'
import './SearchPageBodyContent.css'
import SearchPageBodyContentHeader from './SearchPageBodyContentHeader'

function SearchPageBodyContent() {
    return (
        <div className="SearchPageBodyContent">
            <SearchPageBodyContentHeader />
        </div>
    )
}

export default SearchPageBodyContent
